module.exports = __webpack_public_path__ + "static/consumer-identity-trend---626ae5310d0c6eeaa8b0d16134ea658b.webp";